import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import { Select } from 'components/common/Select';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';

function CouldNotCover({
    isOpen,
    onClose,
    onConfirm,
    appointmentId,
}) {
    const { t } = useTranslation();
    const reasonOpttions = [
        { label: t("couldNotCover.allInterpretersUnavailable"), value: "All Interpreters Unavailable" },
        { label: t("couldNotCover.limitedNotice"), value: "Limited Notice (less than 12 hours)" },
        { label: t("couldNotCover.noInterpretersHired"), value: "No Interpreters Hired with Language" },
        { label: t("couldNotCover.shortNotice"), value: "Short Notice (less than 2 hours)" }
    ];

    const methods = useForm();
    const { control, formState: { errors }, handleSubmit } = methods;
    const [loader, setLoader] = useState(false);

    useEffect(() => {

        methods.reset({ cnc_reason: '' })

    }, [isOpen])



    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
                <form action="" onSubmit={handleSubmit((data) => {
                    setLoader(true);
                    onConfirm(data, "cnc", () => {
                        setLoader(false);
                    })
                })}>
                    <ModalHeader className='header_modal align-items-center'>
                        <h5 className="modal-title_u">{t("couldNotCover.title")}</h5>
                    </ModalHeader>
                    <ModalBody className='modal_form_body'>
                        <div className='step_cards step_1'>
                            <h2>{t("translation.appointmentId")}: {appointmentId}</h2>
                            <div className="row-primary">
                                <h2>{t("translation.reason")}</h2>
                                <div className='w-100'>
                                    {/* Reason */}
                                    <div className="row-primary w-100">
                                        <Controller
                                            name="cnc_reason"
                                            control={control}
                                            rules={{
                                                required: t("couldNotCover.selectReason")
                                            }}
                                            render={({ field }) =>
                                                <>
                                                    <Select
                                                        name="cnc_reason"
                                                        options={reasonOpttions || []}
                                                        {...field}
                                                        value={field.value ? reasonOpttions?.find((opt) => field.value == opt.value) : null}
                                                        onChange={(value) => {
                                                            field.onChange(value);
                                                        }}
                                                    />


                                                    {errors?.cnc_reason?.message && (
                                                        <ErrorMessage
                                                            text={errors?.cnc_reason?.message}
                                                        />
                                                    )}
                                                </>
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <SubmitButton buttonType="submit" className={'yellow'} btnText={t("couldNotCover.submit")} loader={loader} />
                        <button className="table_delete" type='button' onClick={onClose}>{t("billing.cancel")}</button>
                    </ModalFooter>
                </form>
            </Modal>
        </>
    );
}

export default CouldNotCover;